import { useEffect } from 'react';

import { usePageHelpStore } from '@/store/pageHelpStore';

/**
 * Registers the current page (and optional tab/step) for the "What to do on this page?" modal.
 */
export function useRegisterPageHelp(pageTitle: string, tabTitle?: string | null): void {
  const setPageHelpContext = usePageHelpStore((s) => s.setPageHelpContext);
  const clearPageHelpContext = usePageHelpStore((s) => s.clearPageHelpContext);

  useEffect(() => {
    setPageHelpContext(pageTitle, tabTitle ?? null);
    return () => clearPageHelpContext();
  }, [pageTitle, tabTitle, setPageHelpContext, clearPageHelpContext]);
}
